import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, Image, Text } from '@bonusly/design-system';

// Import the kitty illustration
import kittyImage from '../../assets/kitty.png';

export const EmptyState: FC = () => {
	const { t } = useTranslation(['announcements']);

	return (
		<Flex direction="column" alignItems="center" maxW="280px" textAlign="center">
			<Box mb={4}>
				<Image src={kittyImage} alt={t('announcements:carousel.no_announcements')} width="120px" />
			</Box>
			<Text fontWeight="medium" fontSize="md" color="gray.900" mb={1}>
				{t('announcements:carousel.no_announcements')}
			</Text>
			<Text fontSize="sm" color="gray.600">
				{t('announcements:carousel.come_back_later')}
			</Text>
		</Flex>
	);
};
